import React from 'react';
import { Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const UsersPageNavItems = ({ activeKey, onSelect }) => {
  const { t } = useTranslation();
  const loggedInUser = useSelector((state) => state.auth.user);

  const tabs = (() => {
    const accountType = loggedInUser?.account_type;
    const userTabsConfig = window.MARKET_CONSTANTS?.USER_TABS?.[accountType];
    if (!userTabsConfig?.length) return [];
    return userTabsConfig.map(({ eventKey, title}) => ({
      eventKey,
      title: t(title),
    }));
  })();

  return (
    <Nav variant="tabs" defaultActiveKey={activeKey} onSelect={onSelect}>
      {tabs.map((tab) => (
        <Nav.Item key={tab.eventKey}>
          <Nav.Link eventKey={tab.eventKey}>{tab.title}</Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

export default UsersPageNavItems;
